module.exports = __webpack_public_path__ + "img/approve_bg.906d8928.png";